<app-page-wrapper >
    <app-loading-spinner *ngIf="!organizationDetail"></app-loading-spinner>
    <div *ngIf="organizationDetail">
        <div class="my-4 no-print" *ngIf="!activeReport || !activeReport.Parent">
            <a routerLink="/organizations/{{ organizationId }}" class="breadcrumb-link">
            <i class="far fa-angle-left"></i>
            {{ organizationDetail.Description }}
            </a>
        </div>
        <div class="my-4 no-print" *ngIf="activeReport && activeReport.Parent">
            <a class="breadcrumb-link pointer" (click)="navigateReportTree(activeReport.Parent)">
                <i class="far fa-angle-left"></i>
                {{ activeReport.Parent.Name }}
            </a>
        </div>
        <div class="no-print" id="range-selector" *ngIf="!activeReport || !activeReport.Parent">
            <div class="d-flex">
                <div class="detail-name col-md-4" style="font-size:150%">Start&nbsp;Date</div>
                <div class="detail-name col-md-4" style="font-size:150%">End&nbsp;Date</div>
            </div>
            <div class="d-flex">
                <div class="col-md-3"><app-datepicker [(model)]="startDate"></app-datepicker></div>
                <div class="col-md-1"></div>

                <div class="col-md-3"><app-datepicker [(model)]="endDate"></app-datepicker></div>
                <div class="col-md-1"></div>
                
                <div class="col-md-3">
                    <button type="button" class="d-inline-block w-10" (click)="getRootOrgUsageReport()" type="button" class="btn btn-primary col-md-12">
                        Get Report
                    </button>
                </div>
            </div>
            <div class="d-flex mt-1" *ngIf="isInternal()">
                <div class="col-md-8">
                    <!-- Spacing -->
                </div>
                <div class="col-md-3 d-flex justify-content-between header" *ngIf="!fetchingCsv">
                    <div ngbTooltip="Download Carr Report" (click)="downloadCarrReport()">
                       <img src="assets/icon-carr-report.svg" class="custom-icon">
                    </div>
                    <div ngbTooltip="Download Customer Health Report" (click)="downloadLicenseReport()">
                       <img src="assets/icon-customer-health.svg" class="custom-icon">
                    </div>
                    <a (click)="downloadOrgUsageReport()" ngbTooltip="Download CSV Report">
                        <i class="far fa-download pointer"></i>
                    </a>
                </div>
                <div class="col-md-3 header text-center" *ngIf="fetchingCsv">
                    <app-loading-spinner noMargin="true" text=""></app-loading-spinner>
                </div>
            </div>
        </div>

        <div class="my-4 header text-center">
            <app-loading-spinner *ngIf="fetchingReport"></app-loading-spinner>
        </div>
        <div *ngIf="showReport()" class="border px-4 py-4">
            <div class="d-flex mb-3 align-items-center header header-background">
                <h3 class="mr-5">Usage Report</h3>
                <h2>{{ startDate | date }} - {{ endDate | date }}</h2>

                <div class="ml-auto align-items-end d-flex no-print">
                    <div class="ml-4">
                        <a href="/classes/{{activeReport.OrganizationId}}/class/{{activeReport.ClassId}}" 
                         *ngIf="activeReport.ClassId" ngbTooltip="View Class" target="_blank">
                            <img src="assets/icon-view-class.svg" class="custom-icon">
                        </a>
                    </div>
                    <div class="ml-4">
                        <a (click)="printPage('Joy School English')" ngbTooltip="Print">
                            <i class="fal fa-print pointer"></i>
                        </a>
                    </div>
                    <div class="ml-4" *ngIf="!fetchingCsv">
                        <a (click)="downloadOrgUsageReport()" ngbTooltip="Download CSV">
                            <i class="far fa-download pointer"></i>
                        </a>
                    </div>
                    <div class="ml-4" *ngIf="fetchingCsv">
                        <app-loading-spinner noMargin="true" text=""></app-loading-spinner>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div>
                    <div class="detail-name">{{ activeReport.ClassId ? "Class" : "Name" }}</div>
                    <div class="detail-text">{{ activeReport.Name }}</div>
                </div>
                <div *ngIf="activeReport.TeacherName">
                    <div class="detail-name">Teacher</div>
                    <div class="detail-text">{{ activeReport.TeacherName }}</div>
                </div>
                <div>
                    <div class="detail-name">Total Students</div>
                    <div class="detail-text">{{ activeReport.TotalStudents | number }}</div>
                </div>
                <div>
                    <div class="detail-name" >Active Students</div>
                    <div class="detail-text">{{ activeReport.ActiveStudents | number }}</div>
                </div>
                <div>
                    <div class="detail-name" >Average Time per Student</div>
                    <div class="detail-text">{{ formatTimeSpent(getAverageMinutes(activeReport.ActiveStudents, activeReport.TotalMinutes)) }}</div>
                </div>
                <div>
                    <div class="detail-name" >Unit Test Average</div>
                    <div class="detail-text">{{ activeReport.UnitTestTotal ? getUnitTestPercent(activeReport) : " &mdash; " }}%</div>
                </div>
                <div>
                    <div class="detail-name" >Speaking Opportunities</div>
                    <div class="detail-text">{{ (activeReport.SpeakingOpportunities || 0) | number }}</div>
                </div>
            </div>

            <div class="mt-5 blue-separator"></div>

            <table *ngIf="!activeReport.ClassId" class="table">
                <thead>
                    <th>
                        <app-sort-toggle columnName="Name" (orderChange)="updateSort($event)">
                            {{ allSuborgsAreClasses() ? "Class Name" : "Name" }}
                        </app-sort-toggle>
                    </th>
                    <th *ngIf="showTeacherNames()">
                        <app-sort-toggle columnName="Teacher" (orderChange)="updateSort($event)">
                            Teacher
                        </app-sort-toggle>
                    </th>
                    <th>
                        <app-sort-toggle columnName="Total" (orderChange)="updateSort($event)">
                            Total Students
                        </app-sort-toggle>
                    </th>
                    <th>
                        <app-sort-toggle columnName="Active" (orderChange)="updateSort($event)">
                            Active Students
                        </app-sort-toggle>
                    </th>
                    <th>
                        <app-sort-toggle columnName="Time" (orderChange)="updateSort($event)">
                            Average Time per Student
                        </app-sort-toggle>
                    </th>
                    <th>
                        <app-sort-toggle columnName="UnitTest" (orderChange)="updateSort($event)">
                            Unit Test Average
                        </app-sort-toggle>
                    </th>
                    <th>
                        <app-sort-toggle columnName="SpeakingOpportunities" (orderChange)="updateSort($event)">
                            Speaking Opportunities
                        </app-sort-toggle>
                    </th>
                </thead>
                <tbody>
                    <tr class="hover" *ngFor="let suborg of activeReport.Suborgs" (click)="navigateReportTree(suborg)">
                        <td><a class="hover">{{ suborg.Name }}</a></td>
                        <td *ngIf="showTeacherNames()">{{ suborg.TeacherName || "" }}</td>
                        <td>{{ suborg.TotalStudents | number }}</td>
                        <td>{{ suborg.ActiveStudents || 0 | number }} ({{ getActivePercent(suborg.ActiveStudents, suborg.TotalStudents) }}%)</td>
                        <td>{{ formatTimeSpent(getAverageMinutes(suborg.ActiveStudents, suborg.TotalMinutes)) }}</td>
                        <td>{{ suborg.UnitTestTotal ? getUnitTestPercent(suborg) : " &mdash; " }}%</td>
                        <td>{{ (suborg.SpeakingOpportunities || 0) | number }}</td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="showReport() && activeReport.ClassId">
                <app-class-students-report [students]="activeReport.ClassReport.Students" [clickable]="false"></app-class-students-report>
            </div>
        </div>
    </div>
</app-page-wrapper>